/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

/*CSS files*/
import "bootstrap/dist/css/bootstrap.min.css";

/*Javascript Files*/
import $ from "jquery"
import "@popperjs/core"
import "bootstrap/dist/js/bootstrap.min";

if (typeof window !== "undefined") {
  window.$ = window.jQuery = $
}